var map = {
	"./download_deep.png": 1818,
	"./download_light.png": 1819
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/download_.*\.png$
// module id = 436
// module chunks = 0